import AddPage from './AddPage';

export default AddPage;
